import { render, staticRenderFns } from "./ContaLancamentos.vue?vue&type=template&id=a3895898&"
import script from "./ContaLancamentos.vue?vue&type=script&lang=js&"
export * from "./ContaLancamentos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports